import { useEffect, useState } from 'react'
import { subscribeToToasts } from '../lib/toast.js'

export function Toaster() {
  const [message, setMessage] = useState<string | null>(null)

  useEffect(
    () =>
      subscribeToToasts((next) => {
        setMessage(next)
        // Matches the pulseSaved keyframe: fade up, hold, fade.
        window.setTimeout(() => setMessage(null), 2200)
      }),
    [],
  )

  if (!message) return null

  return (
    <div
      role="status"
      className="row elev-lg"
      style={{
        position: 'fixed',
        bottom: 'var(--space-8)',
        left: '50%',
        // No static transform here on purpose: the pulseSaved keyframe
        // (nocturne/keyframes.css) already carries `translate(-50%, …)` on
        // every stop, with fill-mode `both` covering this element's entire
        // mounted lifetime (see the setTimeout below) — that's what actually
        // centres it, for the whole time it's visible.
        gap: 'var(--space-2)',
        padding: 'var(--space-2) var(--space-4)',
        borderRadius: 'var(--radius-md)',
        background: 'var(--color-surface)',
        fontSize: 13,
        animation: 'pulseSaved 2200ms ease-out both',
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--color-accent)' }} />
      {message}
    </div>
  )
}
